import { InjectionToken } from '@angular/core';
import { environment } from '@env/environment';

export const DiMcApiUrl = new InjectionToken(`Mc API URL`, {
  providedIn: 'root',
  factory: () => environment.mc_api_url,
});
